export default "__VITE_ASSET__B8xu78Q9__"